import { InjectionToken } from '@angular/core';

import { INVENTORY_DISCRIMINATOR_FIELD } from './grid-features.interface';

/** Tunable orchestration limits with library defaults. */
export interface GridOrchestrationOptions {
  readonly maxParallelGroups: number;
  readonly maxDiscoveryQueries: number;
  readonly collapseCardinalityThreshold: number;
  readonly bucketPageSize: number;
  readonly nullBucketMaxScanPages: number;
  readonly nullBackendSentinel: string;
  readonly nullDisplayKey: string;
  readonly groupPathDelimiter: string;
  readonly maxRequestConcurrency: number;
  readonly groupHeaderPageSize: number;
  readonly batchFirstPerBucket: number;
  readonly batchFlushMs: number;
  /**
   * Field used for per-type columns and type grouping.
   * Empty when the host has no type discriminator (standalone).
   * Inventory hosts set this to {@link INVENTORY_DISCRIMINATOR_FIELD}.
   */
  readonly discriminatorField: string;
}

export const DEFAULT_GRID_ORCHESTRATION_OPTIONS: GridOrchestrationOptions = {
  maxParallelGroups: 50,
  maxDiscoveryQueries: 50,
  collapseCardinalityThreshold: 25,
  bucketPageSize: 100,
  nullBucketMaxScanPages: 40,
  nullBackendSentinel: '(blank)',
  nullDisplayKey: 'Unknown',
  groupPathDelimiter: '///',
  maxRequestConcurrency: 8,
  groupHeaderPageSize: 50,
  batchFirstPerBucket: 50,
  batchFlushMs: 50,
  discriminatorField: ''
};

/** Inventory override of {@link DEFAULT_GRID_ORCHESTRATION_OPTIONS} (CAR). */
export const INVENTORY_GRID_ORCHESTRATION_OPTIONS: GridOrchestrationOptions = {
  ...DEFAULT_GRID_ORCHESTRATION_OPTIONS,
  discriminatorField: INVENTORY_DISCRIMINATOR_FIELD
};

export const GRID_ORCHESTRATION_OPTIONS: InjectionToken<GridOrchestrationOptions> =
  new InjectionToken<GridOrchestrationOptions>('GRID_ORCHESTRATION_OPTIONS', {
    factory: (): GridOrchestrationOptions => DEFAULT_GRID_ORCHESTRATION_OPTIONS
  });
